/**
 * Test Supabase Certificate Insert
 * Run this to diagnose Supabase insert issues
 */

import { supabase, isSupabaseConfigured } from './supabaseClient';

export async function testSupabaseInsert() {
  console.log('========================================');
  console.log('🧪 SUPABASE INSERT TEST');
  console.log('========================================');
  
  // Step 1: Check configuration
  console.log('1️⃣ Checking configuration...');
  const isConfigured = isSupabaseConfigured();
  console.log('   Configured:', isConfigured);
  console.log('   URL:', process.env.REACT_APP_SUPABASE_URL);
  console.log('   Key exists:', !!process.env.REACT_APP_SUPABASE_ANON_KEY);
  console.log('   Client exists:', !!supabase);
  
  if (!isConfigured || !supabase) {
    console.error('❌ Supabase not configured!');
    return { success: false, error: 'Not configured' };
  }
  
  // Step 2: Test connection
  console.log('\n2️⃣ Testing connection...');
  try {
    const { data, error } = await supabase
      .from('certificates')
      .select('count')
      .limit(1);
    
    if (error) {
      console.error('❌ Connection test failed:', error);
      return { success: false, error: 'Connection failed', details: error };
    }
    console.log('✅ Connection successful');
  } catch (e) {
    console.error('❌ Connection exception:', e);
    return { success: false, error: 'Connection exception', details: e };
  }
  
  // Step 3: Test insert
  console.log('\n3️⃣ Testing insert...');
  const testRecord = {
    student_name: 'Test Student',
    roll_number: 'TEST' + Date.now(),
    institution: 'Test Institution',
    certificate_type: 'Test Certificate',
    file_name: 'test.pdf',
    file_hash: 'test_hash_' + Date.now(),
    cid: 'QmTest' + Date.now(),
    ipfs_url: 'https://gateway.pinata.cloud/ipfs/QmTest',
    upload_date: new Date().toISOString(),
  };
  
  console.log('   Test record:', testRecord);
  
  try {
    const { data, error } = await supabase
      .from('certificates')
      .insert(testRecord)
      .select()
      .single();
    
    if (error) {
      console.error('❌ Insert failed:', error);
      console.error('   Code:', error.code);
      console.error('   Message:', error.message);
      console.error('   Details:', error.details);
      console.error('   Hint:', error.hint);
      
      // Check for common issues
      if (error.code === '42501') {
        console.error('\n⚠️ PERMISSION DENIED!');
        console.error('   This is an RLS (Row Level Security) issue.');
        console.error('   Solutions:');
        console.error('   1. Disable RLS on certificates table');
        console.error('   2. Add policy: CREATE POLICY "Enable insert for all users" ON certificates FOR INSERT WITH CHECK (true);');
        console.error('   3. Use service role key instead of anon key');
      } else if (error.code === '42P01') {
        console.error('\n⚠️ TABLE NOT FOUND!');
        console.error('   The certificates table does not exist in your database.');
      } else if (error.code === '23505') {
        console.error('\n⚠️ UNIQUE CONSTRAINT VIOLATION!');
        console.error('   A record with this hash/CID already exists.');
      }
      
      return { success: false, error: 'Insert failed', details: error };
    }
    
    console.log('✅ Insert successful!');
    console.log('   Inserted data:', data);
    
    // Step 4: Clean up test record
    console.log('\n4️⃣ Cleaning up test record...');
    const { error: deleteError } = await supabase
      .from('certificates')
      .delete()
      .eq('id', data.id);
    
    if (deleteError) {
      console.warn('⚠️ Could not delete test record:', deleteError);
    } else {
      console.log('✅ Test record cleaned up');
    }
    
    console.log('\n========================================');
    console.log('✅ ALL TESTS PASSED!');
    console.log('========================================');
    return { success: true, data };
    
  } catch (e) {
    console.error('❌ Insert exception:', e);
    return { success: false, error: 'Insert exception', details: e };
  }
}

// Auto-run test in development (DISABLED - use manual test button instead)
// if (process.env.NODE_ENV === 'development') {
//   setTimeout(() => {
//     console.log('\n🚀 Running automatic Supabase insert test...\n');
//     testSupabaseInsert().then(result => {
//       if (!result.success) {
//         console.error('\n⚠️ Supabase insert test failed. Check logs above for details.\n');
//       }
//     });
//   }, 2000);
// }
